import { CheckerboardTypes } from ".";
import { XLTFileTypes } from ".";
import {
  MsFileTypes,
  RenditionFileTypes,
  RenditionCodes,
  MediaTypes,
  ImageFileTypes,
} from "./enums";

export function isRendition(asset: Asset): asset is IRenditionAsset {
  return Object.values(RenditionFileTypes).includes(
    asset.file.fileType as RenditionFileTypes
  );
}

export function isRequiredRendition(
  renditionKind: IRenditionKind
): renditionKind is IRenditionKind {
  return Object.values(RenditionCodes).includes(renditionKind.code);
}

export function isImage(asset: Asset): asset is IAsset {
  return (
    asset.media.type === MediaTypes.IMAGE ||
    Object.values(ImageFileTypes).includes(
      asset.file.fileType as ImageFileTypes
    )
  );
}

export function isCheckerboardImage(asset: Asset): asset is IAsset {
  return Object.values(CheckerboardTypes).includes(
    asset.file.fileType as CheckerboardTypes
  );
}

export function isVideo(asset: Asset): asset is IAsset {
  return asset.media.type === MediaTypes.VIDEO;
}

export function isMsFile(asset: Asset): asset is IMSAsset {
  return Object.values(MsFileTypes).includes(
    asset.file.fileType as MsFileTypes
  );
}

export function isXLTFile(asset: Asset): asset is IMSAsset {
  return Object.values(XLTFileTypes).includes(
    asset.file.fileType as XLTFileTypes
  );
}

export function isAudio(asset: Asset): asset is IAsset {
  return asset.media.type === MediaTypes.AUDIO;
}
